import React from 'react';

const Footer = () => {
  return (
    <footer className="text-white bg-gradient-to-b from-[#002726] to-[#0F201E] px-6 pt-10 pb-4 w-full">
      {/* Main Footer Content */}
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between gap-10">
        {/* Left Side */}
        <div className="flex flex-col md:items-start items-center gap-4 w-full">
          <img src="/images/footer-logo.png" alt="Ummah Logo" className="h-20 w-auto" />
          {/* <p className="text-xs mt-4 md:mt-12 md:text-left text-center">
            COPYRIGHT 2026 - UNITED UMMAH
          </p> */}
        </div>
        {/* Right Side */}
        <div className="flex flex-col sm:flex-row gap-8">
          {/* Address */}
          <div className="flex flex-col items-start gap-4 text-sm min-w-[360px]">
            <img src="/images/chat.png" alt="Chat Icon" className="w-10 h-10" />
            <div className="leading-relaxed">
              <p>2200 South Sheridan Way</p>
              <p>Mississauga, ON L5J 2M4</p>
              <p>905.403.8406</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <button className="px-6 py-2 text-black bg-[#f0e4cf] font-semibold">
                CONTACT US
              </button>
              <button className="px-4 py-2 bg-black text-white text-xs">
                FUNERAL LINE: 1-905-403-ARAHZA
              </button>
            </div>
          </div>
          {/* Locations */}
          <div className="flex flex-col items-start gap-4 text-sm min-w-[200px]">
            <img src="/images/mos.png" alt="Mosque Icon" className="w-10 h-10" />
            <div className="leading-relaxed">
              <p>Mississauga - ICC</p>
              <p>Toronto - Jami Mosque</p>
              <p>Yellowknife - ICYK</p>
              <p>Youth Hub - ICC</p>
            </div>
          </div>
          {/* Social */}
          <div className="flex flex-row md:flex-col gap-5 min-w-[200px]">
            <img src="/images/fb.png" alt="Facebook" className="w-7 h-7" />
            <img src="/images/insta.png" alt="Instagram" className="w-7 h-7" />
            <img src="/images/yt.png" alt="YouTube" className="w-7 h-7" />
            <img src="/images/twitter.png" alt="Twitter" className="w-7 h-7" />
          </div>
        </div>
      </div>
      {/* Bottom Center Text */}
      <div className="mt-10 border-t border-white/10 pt-4">
        <p className="text-center text-xs tracking-wide text-white/80">
          (c) 2026 United Ummah. All rights reserved.
        </p>
        {/* <p className="text-center text-xs tracking-wide text-white/80 mt-2">
          Website Creator:{' '}
          <a href="/creator" className="underline hover:text-white transition-colors">
            Sohail Asghar
          </a>
        </p> */}
      </div>
    </footer>
  );
};

export default Footer;
